/**
 * @external {sane~Watcher} https://github.com/amasad/sane
 */
